export const PRIV = 'PRIV'
export const EST = 'EST'
export const CT = 'CT'
